module.exports = __webpack_public_path__ + "img/img_denglu_nor@2x.3228977c.png";